import { buildValueMap } from "./utils";

export const POStatusDef = {
    Created: { value: 1, label: "Created" },
    Issued: { value: 2, label: "Issued" },
    Partial: { value: 3, label: "Partial" },
    ShortClosed: { value: 4, label: "Short Closed" },
    Fulfilled: { value: 5, label: "Fulfilled" },
    Voided: { value: 6, label: "Voided" }
};

export const POReceiptStatusDef = {
    NotBilled: { value: 1, label: "Not Billed" },
    Partial: { value: 2, label: "Partial" },
    FullyBilled: { value: 3, label: "Fully Billed" }
};

export const BillStatusDef = {
    Current: { value: 1, label: "Current" },
    CurrentPartial: { value: 2, label: "Current Partial" },
    Paid: { value: 3, label: "Paid" },
    PastDue: { value: 4, label: "Past Due" },
    PastDuePartial: { value: 5, label: "Past Due Partial" },
    Voided: { value: 6, label: "Voided" }
};

export const ReferenceTypeDef = {
    PO: { value: 1, label: "PO" },
    Release: { value: 2, label: "Release" },
    Confirmation: { value: 3, label: "Confirmation" },
    Pickup: { value: 4, label: "Pickup" },
    Appointment: { value: 5, label: "Appointment" },
    SalesOrder: { value: 6, label: "Sales Order" },
    AdditionalReference: { value: 7, label: "Additional Reference" },
    Container: { value: 8, label: "Container" },
    MasterBOL: { value: 9, label: "MasterBOL" },
    HouseBOL: { value: 10, label: "HouseBOL" },
    BOL: { value: 11, label: "BOL" },
    Tracking: { value: 12, label: "Tracking" },
    Order: { value: 13, label: "Order" },
    ProformaInvoice: { value: 14, label: "Proforma Invoice" }
};

export const POStatus = buildValueMap(POStatusDef);
export const POReceiptStatus = buildValueMap(POReceiptStatusDef);
export const BillStatus = buildValueMap(BillStatusDef);
export const ReferenceType = buildValueMap(ReferenceTypeDef);
